import {map} from 'lodash';
import {errorHandler} from 'utils/errorHandler';

const LOAD = 'server-sts/groups/LOAD';
const LOAD_SUCCESS = 'server-sts/groups/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/groups/LOAD_FAIL';

const LOAD_SUPERVISION_GROUPS = 'server-sts/groups/LOAD_SUPERVISION_GROUPS';
const LOAD_SUPERVISION_GROUPS_SUCCESS = 'server-sts/groups/LOAD_SUPERVISION_GROUPS_SUCCESS';
const LOAD_SUPERVISION_GROUPS_FAIL = 'server-sts/groups/LOAD_SUPERVISION_GROUPS_FAIL';


const EDIT_START = 'server-sts/groups/EDIT_START';
const EDIT_STOP = 'server-sts/groups/EDIT_STOP';
const SAVE = 'server-sts/groups/SAVE';
const SAVE_SUCCESS = 'server-sts/groups/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/groups/SAVE_FAIL';

const DELETE_GROUP = 'server-sts/groups/DELETE_GROUP';
const DELETE_GROUP_SUCCESS = 'server-sts/groups/DELETE_GROUP_SUCCESS';
const DELETE_GROUP_FAIL = 'server-sts/groups/DELETE_GROUP_FAIL';

const CREATE = 'server-sts/groups/CREATE';
const CREATE_SUCCESS = 'server-sts/groups/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/groups/CREATE_FAIL';

const USER_TO_GROUP = 'server-sts/groups/USER_TO_GROUP';
const USER_TO_GROUP_SUCCESS = 'server-sts/groups/USER_TO_GROUP_SUCCESS';
const USER_TO_GROUP_FAIL = 'server-sts/groups/USER_TO_GROUP_FAIL';

const FICHE_TO_GROUP = 'server-sts/groups/FICHE_TO_GROUP';
const FICHE_TO_GROUP_SUCCESS = 'server-sts/groups/FICHE_TO_GROUP_SUCCESS';
const FICHE_TO_GROUP_FAIL = 'server-sts/groups/FICHE_TO_GROUP_FAIL';

const REMOVE_USER_FROM_GROUP = 'server-sts/groups/REMOVE_USER_FROM_GROUP';
const REMOVE_USER_FROM_GROUP_SUCCESS = 'server-sts/groups/REMOVE_USER_FROM_GROUP_SUCCESS';
const REMOVE_USER_FROM_GROUP_FAIL = 'server-sts/groups/REMOVE_USER_FROM_GROUP_FAIL';

const REMOVE_SITE_FROM_GROUP = 'server-sts/groups/REMOVE_SITE_FROM_GROUP';
const REMOVE_SITE_FROM_GROUP_SUCCESS = 'server-sts/groups/REMOVE_SITE_FROM_GROUP_SUCCESS';
const REMOVE_SITE_FROM_GROUP_FAIL = 'server-sts/groups/REMOVE_SITE_FROM_GROUP_FAIL';

const CLEAR_GROUPS = 'server-sts/groups/CLEAR_GROUPS';

import _ from 'underscore';


const initialState = {
  loaded: false,
  loading: false,
  created: false,
  groupCreatedError:false,
  editing: {},
  saveError: {},
  saveSuccess:false,
  data:[] 
};

export default function reducer(state = initialState, action = {}) {

	
  switch (action.type) {
  
  
	  case LOAD_SUPERVISION_GROUPS:
	    return {
	      ...state,
	      loading: true
	    };
	  case LOAD_SUPERVISION_GROUPS_SUCCESS:
	  
	    return {
	      ...state,
	      //loading_sp_groups: false,
	      //sp_groups_loaded: true,
	      supervision_groups: action.result,
	      //sp_groups_error: null 
	    };
	  case LOAD_SUPERVISION_GROUPS_FAIL:
	
	    return {
	      ...state,
	      //loading: false,
	      //loaded: false,
	      supervision_groups: null,
	      error:errorHandler(action.error.code)
	    };
	  

    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
    	
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      };
    case LOAD_FAIL:

      return {
        ...state,
        loading: false,
        loaded: false,
        data: [], 
        error:errorHandler(action.error.code)
      };
    case EDIT_START:

      return {
        ...state,
        editing: {
          [action.id]: true
        }
      };
    case EDIT_STOP:
      return {
        ...state,
        editing: {
          [action.id]: false
        },
        saveSuccess: false,
        saveError : {
        	...state.saveError,
        	[action.id]: null,
        }
      };

    case CREATE:
      return {
    		...state,
    		loading:true
    	};

    case CREATE_SUCCESS:
    	return {
				...state,
				created:true,
				loading:false,
				groupCreatedError:false,
				data:action.result.groups,
			};

    case CREATE_FAIL:
    	return {
				...state,
				created:false,
				loading:false,
				groupCreatedError:errorHandler(action.error.code),
				error: errorHandler(action.error.code),
			};
			
    case USER_TO_GROUP:
    	return {
	    	...state, 
	    
	    	loading:true
	    }
    
    case USER_TO_GROUP_SUCCESS:
    	return {
	    	...state, 
	    	data:action.result, 
	    	loading:false
	    }
    
    case USER_TO_GROUP_FAIL:
    	return {...state, error: errorHandler(action.error.code), loading:false}
			
			
    case FICHE_TO_GROUP:
    	return {...state, loading:true}
    
    case FICHE_TO_GROUP_SUCCESS:
    	return {
    		...state,
	    	data:action.result, 
	    	loading:false
	    }
    
    case FICHE_TO_GROUP_FAIL:
    	return {
        ...state,      
        error: errorHandler(action.error.code), 
        loading:false
      }
    	
    	
    case REMOVE_SITE_FROM_GROUP:
    	return {...state,loading:true}	
    	
    case REMOVE_SITE_FROM_GROUP_SUCCESS:
    	state.groups = action.result
    	return {...state, error:false, loading:false, success:true, data:action.result}
    	
    case REMOVE_SITE_FROM_GROUP_FAIL:
    	return {...state, error:true, loading:false}
    	
    	
    case REMOVE_USER_FROM_GROUP:
    	return {...state,loading:true}	
    	
    case REMOVE_USER_FROM_GROUP_SUCCESS:
    	return {...state, error:false, loading:false, success:true, data:action.result}
    	
    case REMOVE_USER_FROM_GROUP_FAIL:
    	return {
        ...state, 
      
        error: errorHandler(action.error.code), 
        loading:false
      }
    	
    case CLEAR_GROUPS:
    	return {
    		...state, 
    		data:[],
    		loaded:false
    	}
    
    
    

    case SAVE:
      return state; // 'saving' flag handled by redux-form

    case SAVE_SUCCESS:
      var groups = action.result.groups;
      return {
        //...state,
        data: groups,
        editing: {
          ...state.editing,
          [action.result.id]: false
        },
        saveError: {
          ...state.saveError,
          [action.result.id]: null
        },
        saveSuccess: true,
        saveErrors: false
      };
    case SAVE_FAIL:
      return {
        ...state,
        error: errorHandler(action.error.code),
        saveError: {
          ...state.saveError,
          [action.id]: errorHandler(action.error.code)
        },
        saveSuccess: false,
      }
    default:
      return state;
  }
}

export function isLoaded(globalState) {
	
  return globalState.groups && globalState.groups.loaded;
}

export function createGroup(values, params) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (group) => group.post('/group/create', {
      data: {
      	values,
      	params,
      }
    })
  };
}

export function load(params, origin=null, order=null) {

	if(origin == null) {
		var url = '/group/load';
		
		return {
	    promise: (client) => client.post(url, {data:{params, order}}),
	    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL]
	  };
		
		
	} else  if( origin == 'supervision' ) {
		var url = '/group/loadSupervisionGroups';
		
		return {
	    promise: (client) => client.post(url, {data:{params, order}}),
	    types: [LOAD_SUPERVISION_GROUPS, LOAD_SUPERVISION_GROUPS_SUCCESS, LOAD_SUPERVISION_GROUPS_FAIL]
	  };
		
	}

 
}

export function save(values, params) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: values.id,
    promise: (client) => client.post('/group/update', {
      data: {values, params}
    })
  };
}

export function deleteGroup(groupId, params) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: (group) => group.post('/group/deleteGroup', {
      data: {id:groupId, params}
    })
  };
}


export function userToGroup(user, g_id, params) {
  return {
    types: [USER_TO_GROUP, USER_TO_GROUP_SUCCESS, USER_TO_GROUP_FAIL],
    promise: (group) => group.post('/group/userToGroup', {
      data: {g_id:g_id, user, params}
    })
  };
}

export function siteToGroup(site, g_id, params) {
	
  return {
    types: [FICHE_TO_GROUP, FICHE_TO_GROUP_SUCCESS, FICHE_TO_GROUP_FAIL],
    promise: (group) => group.post('/group/siteToGroup', {
      data: {g_id:g_id, site, params}
    })
  };
}

export function removeUserFromGroup(g_id, u_id, params) {
  return {
    types: [REMOVE_USER_FROM_GROUP, REMOVE_USER_FROM_GROUP_SUCCESS, REMOVE_USER_FROM_GROUP_FAIL],
    promise: (group) => group.post('/group/removeUserFromGroup', {
      data: {g_id, u_id, params}
    })
  };
}


export function removeSiteFromGroup(g_id, s_id, params) {
  return {
    types: [REMOVE_SITE_FROM_GROUP, REMOVE_SITE_FROM_GROUP_SUCCESS, REMOVE_SITE_FROM_GROUP_FAIL],
    promise: (group) => group.post('/group/removeSiteFromGroup', {
      data: {g_id, s_id, params}
    })
  };
}

export function editStart(id) {
  return { type: EDIT_START, id };
}

export function editStop(id) {
  return { type: EDIT_STOP, id };
}


export function clearGroups() {
  return { type: CLEAR_GROUPS };
}
